import { query } from '@kk/utils';

export function handleVisitSourceURL(url) {
    const visitsource = parseInt(query.get('visitsource'), 10) || 0;
    const reg = /visitsource=(\d*)/;
    if (reg.test(url)) {
        return url;
    } else {
        const urlArr = url.split('#');
        return `${urlArr[0]}&visitsource=${visitsource}${urlArr[1] ? '#' + urlArr[1] : ''}`;
    }
}
